export default __webpack_public_path__ + "static/media/football.16851d44.jpg";